import { Chip } from '@mui/material';

// Función para formatear fechas sin desfase de zona horaria
const formatearFecha = (fechaStr) => {
    if (!fechaStr) return '';

    // Parsear la fecha como string sin conversión de zona horaria
    const partes = fechaStr.split(/[- :]/);
    const fecha = new Date(partes[0], partes[1] - 1, partes[2], partes[3] || 0, partes[4] || 0, partes[5] || 0);

    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    let horas = fecha.getHours();
    const minutos = String(fecha.getMinutes()).padStart(2, '0');
    const ampm = horas >= 12 ? 'PM' : 'AM';

    horas = horas % 12;
    horas = horas ? horas : 12; // 0 debe ser 12

    return `${dia}-${mes}-${año} ${String(horas).padStart(2, '0')}:${minutos} ${ampm}`;
};

const columns = (cambioEstatus, ctl) => ({
    asignacion: [
        {
            label: 'Curso',
            name: 'nombreCurso',
            filtrar: true
        },
        {
            label: 'Grupo',
            name: 'nombreGrupo',
            filtrar: true
        },
        {
            label: 'Fecha Inicio',
            name: 'fechaInicioFormateada',
            type: (row) => row.fechaInicioCompleta || formatearFecha(row.fechaInicioCurso),
            filtrar: true
        },
        {
            label: 'Fecha Fin',
            name: 'fechaFinFormateada',
            type: (row) => row.fechaFinCompleta || formatearFecha(row.fechaFinCurso),
            filtrar: true
        },
        {
            label: 'Fecha Creación',
            name: 'fechaCreacionFormateada',
            type: (row) => row.fechaCreacionCompleta || formatearFecha(row.fechaCreacion),
            filtrar: true
        },
        {
            label: 'Estatus',
            name: 'estatus',
            filtrar: false,
            type: { opcion: 'switch', accion: cambioEstatus }
        }
    ]
});

export default columns;
